import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as LogoWhite } from "shared/assets/images/logo-strm.svg";
import { ReactComponent as LogoBlack } from "shared/assets/images/logo-black.svg";
import WavyBorderWhite from "shared/assets/images/career-diagnose/wavy-border.png";
import WavyBorderBlack from "shared/assets/images/career-diagnose/wavy-border-black.png";
import "./ExportCareerDiagnose.scss";
import moment from "moment";

interface props {
  id: string;
  className: string;
  shade: "white" | "black";
  artistName: string;
  lastUpdate: string;
}

const shadeProps = {
  white: {
    logo: LogoBlack,
    border: WavyBorderBlack,
  },
  black: {
    logo: LogoWhite,
    border: WavyBorderWhite,
  },
};

const formatDate = (date: string) => {
  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format("DD/MM/YYYY") : "-";
};

const ExportCareerDiagnosePage: React.FC<props> = (props) => {
  const { children, id, className, shade, artistName, lastUpdate } = props;
  const { t } = useTranslation("radar");
  const shadeInfo = shadeProps[shade];
  return (
    <div
      id={id}
      className={`export-diagnose-page ${shade} ${className}`}
      style={{
        padding: 32,
        height: 1754,
        width: 1240,
      }}
    >
      <Row>
        <Col xs={24}>
          <Row justify="space-between">
            <Col xs={4}>
              <shadeInfo.logo />
            </Col>
            <Col xs={12} style={{ textAlign: "center" }}>
              <h1 className="title-career-diagnose">
                {t("pages.CareerDiagnose.title")} ®
              </h1>
            </Col>
            <Col xs={4} style={{ textAlign: "end" }}>
              <span>{artistName}</span>
              <span style={{ display: "block" }}>{formatDate(lastUpdate)}</span>
            </Col>
          </Row>
          <img
            src={shadeInfo.border}
            alt="wavy border"
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={24} className="container">
          {children}
        </Col>
      </Row>
    </div>
  );
};

export default ExportCareerDiagnosePage;
